export default {
  NAMESPACE: 'Wix_Ads',
  MAIN_TEXT_KEY: 'Wix_Ads_2_top_banner',
  MAIN_TEXT_DEFAULT:
    'This site was designed with the {Wix} website builder. Create your website today.',
  BUTTON_TEXT_KEY: 'Wix_Ads_2_top_banner_CTA',
  BUTTON_TEXT_DEFAULT: 'Start Now',
  wixLogoPlaceHolder: '{Wix}',
};
